import api from 'config/axios';
import AppService from 'common/app-service';

interface SignInData {
  email: string;
  password: string;
}

export default class AuthService extends AppService {
  constructor() {
    super('accounts/oauth2', api);
  }

  async signIn(data: SignInData) {
    const { email: username, password } = data;

    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    const response = await this.api.post(`${this.servicePath}/token`, formData, { headers: { 'content-type': 'multipart/form-data' } });

    return response.data;
  }

  async recoverPassword(email: string) {
    const response = await this.api.post(`${this.servicePath}/recover-password`, email);

    return response.data;
  }
}
